import { render, staticRenderFns } from "./IconDocumentAdd.vue?vue&type=template&id=3f6a141c&functional=true&"
import script from "./IconDocumentAdd.vue?vue&type=script&lang=js&"
export * from "./IconDocumentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports